import {mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums"

export const getFormData = (data) => {
    const initialData = {
        fName: "",
        lName: "",
        phone: "",
        email: "",
        password: "",
        status: "",
        image: "",
        customer: {
            gender: "",
        },
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {
            header: "Name",
            field: "fName",
            render: (item) => {
                return <>{item.fName}{item?.lName ? ` ${item.lName}` : ''}</>;
            },
        },
        {header: "Phone", field: "phone"},
        {header: "Email", field: "email"},
        {header: "Role", field: "role"},
        {header: "Status", field: "status"},
    ];
    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} onDelete={deleteHandler}/>;
        },
    });
    return tableColumns;
};


export const getTableData = ({items = [], categories}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        fName: item.fName,
        lName: item.lName,
        phone: item.phone,
        email: item.email,
        role: item.role,
        status: reverseEnum(Status)[item.status]
    }));
}


export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            FirstName: item?.fName,
            LastName: item?.lName,
            Phone: item?.phone,
            Email: item?.email,
            Password: item?.password,
            Gender: item?.customer?.gender,
            status: reverseEnum(Status)[item.status]
        }
    };
}
